<template>
  <div class="style-msg2 errormsg">
        <div class="msgtitle">Σφάλματα:</div>
        <div class="sb-msg">
            <ul>
                <!-- <li v-for="alert in alerts" :key="alert">{{alert}}</li> -->
                <li v-for="alert in alerts" v-bind:key="alert">{{alert}}</li>
            </ul>
        </div>
    </div>
</template>

<script>

export default {
  props:{
      alerts:Array
      },
  data() {
    return {};
  },

  async mounted() {},
};
</script>
<style lang="scss" scoped>
//colors
$color_mine_shaft_approx: #444;
$black_10: rgba(0, 0, 0, 0.1);
$black_20: rgba(0, 0, 0, 0.2);
$color_vanilla_ice_approx: #f8d7da;
$color_merlot_approx: #721c24;
$white_50: rgba(255, 255, 255, 0.5);
$black_15: rgba(0, 0, 0, 0.15);

//@extend-elements
//original selectors
//.style-msg2 .msgtitle, .style-msg2 .sb-msg
%extend_1 {
    display: block;
    padding: 3px 15px;
    border-left: 1px solid $white_50;
    font-size: 0.9rem;
    
}

.style-msg2 {
    position: relative;
    display: block;
    color: $color_mine_shaft_approx;
    border-left: 4px solid $black_10;
    margin-bottom: 20px;
    border-left: 4px solid $black_20;
    border-radius: 4px;

    .msgtitle {
        @extend %extend_1;
        background: $black_15;
        border-top: none;
        border-bottom: none;
        font-weight: bold;
        border-radius: 4px;
    }

    .sb-msg {
        @extend %extend_1;
        font-weight: normal;
    }

    ul {
        margin: 0;
        list-style-type: disc;
        padding-left: 1rem;

        li {
            margin: 0;
            padding: 0;
            text-align: left;
        }
    }
}

.errormsg {
    background: $color_vanilla_ice_approx;
    color: $color_merlot_approx;
    width: 100%;
}

</style>